/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchResultItemDto
 */
export interface SearchResultItemDto {
    /**
     * 
     * @type {string}
     * @memberof SearchResultItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SearchResultItemDto
     */
    category: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchResultItemDto
     */
    title: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchResultItemDto
     */
    subTitle?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SearchResultItemDto
     */
    amount?: number | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SearchResultItemDto
     */
    meta?: { [key: string]: string; } | null;
    /**
     * 
     * @type {string}
     * @memberof SearchResultItemDto
     */
    detailUrl: string | null;
}

/**
 * Check if a given object implements the SearchResultItemDto interface.
 */
export function instanceOfSearchResultItemDto(value: object): value is SearchResultItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('detailUrl' in value) || value['detailUrl'] === undefined) return false;
    return true;
}

export function SearchResultItemDtoFromJSON(json: any): SearchResultItemDto {
    return SearchResultItemDtoFromJSONTyped(json, false);
}

export function SearchResultItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchResultItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'category': json['category'],
        'title': json['title'],
        'subTitle': json['subTitle'] == null ? undefined : json['subTitle'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'detailUrl': json['detailUrl'],
    };
}

export function SearchResultItemDtoToJSON(json: any): SearchResultItemDto {
    return SearchResultItemDtoToJSONTyped(json, false);
}

export function SearchResultItemDtoToJSONTyped(value?: SearchResultItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'category': value['category'],
        'title': value['title'],
        'subTitle': value['subTitle'],
        'amount': value['amount'],
        'meta': value['meta'],
        'detailUrl': value['detailUrl'],
    };
}

